__turbopack_context__.v({
  "avatarButton": "sRxflq_avatarButton",
  "backdrop": "sRxflq_backdrop",
  "backdrop__active": "sRxflq_backdrop__active",
  "desktop": "sRxflq_desktop",
  "desktop__searching": "sRxflq_desktop__searching",
  "dropdown": "sRxflq_dropdown",
  "dropdown__dot": "sRxflq_dropdown__dot",
  "dropdown__icon": "sRxflq_dropdown__icon",
  "dropdown__incomplete": "sRxflq_dropdown__incomplete",
  "dropdown__item": "sRxflq_dropdown__item",
  "dropdown__item__active": "sRxflq_dropdown__item__active",
  "dropdown__item__underline": "sRxflq_dropdown__item__underline",
  "dropdown__list": "sRxflq_dropdown__list",
  "dropdown__text": "sRxflq_dropdown__text",
  "favoriteTeamButton": "sRxflq_favoriteTeamButton",
  "favoriteTeamIcon": "sRxflq_favoriteTeamIcon",
  "hamburger": "sRxflq_hamburger",
  "hamburger__line": "sRxflq_hamburger__line",
  "header": "sRxflq_header",
  "item": "sRxflq_item",
  "item__active": "sRxflq_item__active",
  "item__dot": "sRxflq_item__dot",
  "item__incomplete": "sRxflq_item__incomplete",
  "item__underline": "sRxflq_item__underline",
  "items": "sRxflq_items",
  "left": "sRxflq_left",
  "logo": "sRxflq_logo",
  "menu": "sRxflq_menu",
  "menu__active": "sRxflq_menu__active",
  "mobile": "sRxflq_mobile",
  "mobile__noAvatar": "sRxflq_mobile__noAvatar",
  "mobile__searchActive": "sRxflq_mobile__searchActive",
  "mobile__searching": "sRxflq_mobile__searching",
  "navbar": "sRxflq_navbar",
  "profileAvatar": "sRxflq_profileAvatar",
  "profileLogo": "sRxflq_profileLogo",
  "right": "sRxflq_right",
  "search": "sRxflq_search",
  "shimmer": "sRxflq_shimmer",
  "text-bar-sweep": "sRxflq_text-bar-sweep",
});
